import { track } from '@/utils/analytics';
import { LISTING_ORIGIN_TYPES } from '@/constants';
import BaseAction from './base.action';

export default class BaseOpenModalAction extends BaseAction {
  #analyticEvent = null;

  constructor(config = {}) {
    super(config);
    this.#analyticEvent = config.analyticEvent;
    this.modalWindow = config.modalWindow;
    this.modalData = config.modalData;
  }

  async execute(listing) {
    this.#trackExecution(listing);
    const modalWindowResult = await this.openModal(listing);

    this.propagateResult(listing, modalWindowResult);
  }

  #trackExecution({ listingId, origin }) {
    track(this.#analyticEvent, {
      listingId,
      listingType: LISTING_ORIGIN_TYPES[origin] || origin,
    });
  }
}
